// extracted by mini-css-extract-plugin
module.exports = {"collapsible":"styles_collapsible__3pafN","animatedContents":"styles_animatedContents__4j7D1"};